import React from "react";
import RegularButton from "components/CustomButtons/Button"
import DescriptionIcon from '@mui/icons-material/Description';
import { blue } from '@mui/material/colors';
import { useDispatch, useSelector } from "react-redux";
import { getSurvey } from "redux/actions/surveys/surveysAction";
import { useToggle } from "hooks/useToggle";
import { ModalV2 } from "components/Modal/ModalV2";
import { SurveyQuestions } from "./SurveyQuestions";
const selectColor = (status) => {
  const statusLowerCase = status.toLowerCase().replaceAll(' ', '')
  const bad = 'malestado'
  const regular = 'regular'
  const good = 'bueno'
  switch (statusLowerCase) {
    case bad:
      return '#f6685e'
    case regular:
      return '#2c387e'
    case good:
      return '#4caf50'
    default: return ''
  }
}

export const columns = [
  {
    Header: "Unidad",
    accessor: "unitNumber",
    filterable: true,
    filterMethod: (filter, row) => {
      return row.unitNumber.toLowerCase().includes(filter.value.toLowerCase())
    },
  },
  {
    Header: "Chofer",
    accessor: "driver",
    filterable: true,
    filterMethod: (filter, row) => {
      return row.driver.toLowerCase().includes(filter.value.toLowerCase())
    },
  },
  {
    Header: "Encuesta",
    accessor: "survey",
    filterable: true,
    filterMethod: (filter, row) => {
      return row.survey.toLowerCase().includes(filter.value.toLowerCase())
    },
  },
  {
    Header: "Status",
    accessor: "status",
    filterable: true,
    filterMethod: (filter, row) => {
      return row.status.toLowerCase().includes(filter.value.toLowerCase())
    },
    Cell: ({ original }) => <p style={{
      color: selectColor(original.status),
      fontWeight: 500
    }}>{original.status}</p>
  },
  {
    Header: "Acciones",
    accessor: "capacity",
    filterable: true,
    style: { textAlign: "center" },
    Cell: ({ original }) => {
      const dispatch = useDispatch()
      const [open, setOpen] = useToggle()
      const { isLoadingComp } = useSelector(({search}) => search)
      const handleNav = () => {
        dispatch(getSurvey({id: original.id, unit:original?.unit?.type}))
        setOpen()
        // hist.push(`/admin/survey/${original.id}`)
      }

      return (
        <>
        <div 
          style={{
            display: 'flex', 
            justifyContent: 'flex-end',
            gap: 4
          }}
          >
          <RegularButton
            justIcon
            round
            color="transparent"
            onClick={handleNav}
            >
            <DescriptionIcon style={{color: blue[500]}}/>
          </RegularButton>
        </div>
        <ModalV2
          open={open}
          onClose={setOpen}
          toRight
          isLoading={isLoadingComp?.loadingSurvey}
          isLarge
        >
          <SurveyQuestions hideBackBtn onClose={setOpen}/>
        </ModalV2>
            </>
      )
    }
  },

]